import {
  HOMMES,
  FEMMES,
  UNISEXE,
  GENDER,
  BRAND,
  IDEAL_POUR,
  POUR,
  ECONOMISEZ,
  AUBAINES,
  LIQUIDATION,
  BRANDSREGEX,
  DEALSREGEX,
  GENDERS_REGEX,
  GENDERS_CATEGORY_REGEX,
  NEWARRIVALSREGEX,
  NOUVEAU,
  CLEARANCEREGEX,
  SALEREGEX,
} from './constants';
import { SortedURLSearchParams } from './getEnH1AndPageTitle';
import { parseAlgoliaUrl } from '../algolia/helpers';
import brands from '../../public/brands.json';

const toLowerCase = (value?: string) => (value ? value.toLowerCase() : value);

const paramsToObject = (urlSearchParams: URLSearchParams) => {
  const result: SortedURLSearchParams = {
    genders: [],
    brands: [],
    idealFor: [],
    promotions: [],
  };
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of urlSearchParams) {
    const searchParam = key.toLowerCase();

    if (searchParam.includes(GENDER)) {
      const splitGenders = value.split(',');

      result.genders = splitGenders.map((g) => {
        return `${POUR}${g}`;
      });
    }
    if (key.includes(BRAND)) {
      result.brands = value.split(',');
    }
    if (key.includes(IDEAL_POUR)) {
      result.idealFor = value.split(',');
    }
    if (searchParam.includes('promotions')) {
      result.promotions = value.split(','); //toLocaleLowerCase();
    }
  }
  return result;
};

export const getFrH1AndPageTitle = (url?: string, pageTitle?: string) => {
  const [path, query, ...rest] = url?.split('?') ?? [];
  if (!rest || rest?.length !== 0) {
    console.warn('url contains more than 1 "?"', { url, rest });
  }

  const queryParams = `?${query}`;
  const urlSearchParams = new URLSearchParams(queryParams.toLowerCase());

  const objectOfParams = paramsToObject(
    urlSearchParams
  ) as unknown as SortedURLSearchParams;

  const promotionsParam = objectOfParams.promotions;

  const brandsRegex = new RegExp(BRANDSREGEX);
  const matchedBrand = path?.match(brandsRegex);
  const gendersCategoryRegex = new RegExp(GENDERS_CATEGORY_REGEX);
  const matchedGenderAndCategory = path?.match(gendersCategoryRegex);
  const gendersRegex = new RegExp(GENDERS_REGEX);
  const matchedGender = path?.match(gendersRegex);
  const dealsRegex = new RegExp(DEALSREGEX);
  const matchedDeal = path?.match(dealsRegex);
  const isAllProducts = path?.match(/produits$/);
  const newArrivalsRegex = new RegExp(NEWARRIVALSREGEX);
  const matchedNewArrivals = path?.match(newArrivalsRegex);
  const clearanceRegex = new RegExp(CLEARANCEREGEX);
  const matchedClearance = path?.match(clearanceRegex);
  const saleRegex = new RegExp(SALEREGEX);
  const matchedSale = path?.match(saleRegex);

  const { brandIdentifier = '' } = parseAlgoliaUrl(path, 'en');
  const brandName = brands[brandIdentifier as keyof typeof brands];

  let badge, brand, gender, idealFor;
  let startingPageTitle = matchedBrand ? undefined : pageTitle?.toLowerCase();

  const isTitleGenderless =
    !pageTitle?.match(/(hommes|femmes|unisexe)/i) && !matchedGender;

  if (pageTitle === '' && matchedGenderAndCategory) {
    // if gender in path regex extracts title as well. Sometimes title is further down the url. eg.
    // en/products/footwear/womens/c/2390 - 'footwear' is before /women
    // en/products/footwear/kids/boots/casual-boots/c/2372 - 'boots' is currently grabbed
    startingPageTitle = (
      matchedGenderAndCategory[3] === 'c'
        ? matchedGenderAndCategory[1]
        : matchedGenderAndCategory[3]
    )?.replace(/-/g, ' ');
  }

  objectOfParams.genders.forEach(toLowerCase);
  promotionsParam.forEach(toLowerCase);
  objectOfParams.idealFor.forEach(toLowerCase);

  // Extract Gender from the query string
  if (objectOfParams?.genders.length === 1 && !matchedGenderAndCategory) {
    gender = objectOfParams?.genders[0];
  }

  if (
    (objectOfParams.genders.length === 2 &&
      objectOfParams.genders.includes(`${POUR}${UNISEXE}`) &&
      objectOfParams.genders.includes(`${POUR}${FEMMES}`)) ||
    (matchedGenderAndCategory?.[2] === 'femmes' && isTitleGenderless)
  ) {
    gender = `${POUR}${FEMMES}`;
  }

  if (
    (objectOfParams.genders.length === 2 &&
      objectOfParams.genders.includes(`${POUR}${UNISEXE}`) &&
      objectOfParams.genders.includes(`${POUR}${HOMMES}`)) ||
    (matchedGenderAndCategory?.[2] === 'hommes' && isTitleGenderless)
  ) {
    gender = `${POUR}${HOMMES}`;
  }

  // If none was found, try to extract gender from the url path
  if (!gender && matchedGender && matchedGender.length > 0) {
    // Check for a special case: if we see kids, then we don't want to set the gender
    // Unless kids is at the end of the path
    if (
      matchedGender[0] !== '/enfants' ||
      path.split('/').pop() === 'enfants'
    ) {
      // Check for when we have matched a gender of kids via the above logic, but the page title ALREADY has kids in it
      // In this case, we don't want to use the kids gender since it would double up in the H1
      if (
        !(
          matchedGender[0].includes('enfants') &&
          (pageTitle?.includes('enfants') ||
            startingPageTitle?.includes('enfants'))
        )
      ) {
        gender = `${POUR}${matchedGender[0].replace('/', '')}`;
      }
    }
  }

  if (objectOfParams.brands.length === 1 && !matchedBrand) {
    // if a brand filter is applied and the url isn't a specific brand like /brands/the-north-face

    const splitBrand = objectOfParams?.brands[0].split(' ');
    const capitalizeBrand = splitBrand
      .map((item) => item.charAt(0).toUpperCase() + item.slice(1))
      .join(' ');

    brand = `de ${capitalizeBrand}`; // if brand capitalization is a big deal could grab it from getAllBrands and match it?

    if (isAllProducts) {
      // new branded pages remove 'All products', this ensures c/100 (old brand pages) match

      if (
        objectOfParams.idealFor.length === 0 &&
        promotionsParam.length === 0
      ) {
        brand = `de ${capitalizeBrand}`;
      }
    }
  }

  if (matchedNewArrivals) {
    badge = `${NOUVEAU} :`;
  }

  if (matchedClearance) {
    badge = `${LIQUIDATION} :`;
  }

  if (matchedSale) {
    badge = `${ECONOMISEZ} :`;
  }

  if (
    (promotionsParam.includes(ECONOMISEZ) &&
      promotionsParam.includes(LIQUIDATION)) ||
    matchedDeal
  ) {
    badge = `${AUBAINES}`;
    const dealRegex = new RegExp(badge, 'i');
    if (startingPageTitle?.match(dealRegex)) {
      startingPageTitle = startingPageTitle.replace(dealRegex, '').trim();
    }
    if (objectOfParams.genders.length > 0) {
      startingPageTitle = undefined;
    }
  }

  if (objectOfParams.idealFor.length === 1) {
    idealFor = `${objectOfParams.idealFor[0]} :`;
  }
  if (promotionsParam.length === 1) {
    badge = `${promotionsParam[0]} :`;
    startingPageTitle = startingPageTitle?.toLocaleLowerCase();
  }

  if (matchedBrand) {
    if (idealFor || badge || startingPageTitle || brand) {
      brand = `de ${brandName}`;
    } else {
      brand = brandName;
    }
  }

  if (brand && idealFor && isAllProducts) {
    startingPageTitle = undefined;
  }

  let items = [idealFor, badge, startingPageTitle, brand, gender];

  if (badge && gender) {
    // 'Liquidation : tous les produits pour femmes '
    items = [badge, startingPageTitle, gender];
  }
  if (badge && brand) {
    // 'Liquidation : de Black Diamond tous les produits'
    items = [badge, brand, startingPageTitle];
    if (badge === AUBAINES) {
      if (isAllProducts) {
        startingPageTitle = undefined;
      }
      // 'Aubaines tous les produits de The North Face';
      items = [badge, startingPageTitle, brand];
    }
  }
  if (badge && idealFor) {
    // "Liquidation : tenue décontractée : tous les produits"
    items = [badge, idealFor, startingPageTitle];
    if (badge === AUBAINES) {
      // 'Tenue décontractée : aubaines tous les produits';
      items = [idealFor, badge, startingPageTitle];
    }
  }
  if (badge && brand && idealFor) {
    // "Liquidation : ski de haute route : de Black Diamond tous les produits"
    items = [badge, idealFor, brand, startingPageTitle];
  }
  if (
    (badge && brand && gender) ||
    (matchedBrand && badge && startingPageTitle && gender)
  ) {
    if (isAllProducts) {
      startingPageTitle = undefined;
    }
    // "Nouveau : de Black Diamond tous les produits pour femmes"
    items = [badge, brand, startingPageTitle, gender];
  }
  if (badge && gender && idealFor) {
    // "Liquidation : tenue décontractée : pour femmes tous les produits"
    items = [badge, idealFor, gender, startingPageTitle];
  }
  if (gender && badge && brand && idealFor) {
    items = [badge, idealFor, brand, startingPageTitle, gender];
    if (badge === AUBAINES) {
      // 'Tenue décontractée : aubaines tous les produits';
      items = [idealFor, badge, brand, startingPageTitle, gender];
    }
  }

  // Handle categories being selected beneath brands, leading to pageTitle existing but not startingPageTitle
  // such as /en/products/brands/patagonia/camping-and-hiking/hiking-clothing
  // In this case, we should add the page title to the end of the H1.
  // But! We shouldn't do it when the page is just /en/products and the brand is being provided by query string
  // And, we also shouldn't do it when we are already on the brand page (i.e., the brand page is already the page title)
  if (
    brand &&
    pageTitle &&
    !startingPageTitle &&
    pageTitle.toLowerCase() !== 'tous les produits' &&
    pageTitle !== brand &&
    pageTitle?.toLowerCase() !== brandName?.toLowerCase()
  ) {
    items.push(pageTitle);
  }

  const joinTitle = items.filter(Boolean).join(' ').trim();

  const capitalizedTitle = `${joinTitle
    .charAt(0)
    .toUpperCase()}${joinTitle.slice(1)}`;

  return capitalizedTitle;
};
